import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectRoutineItemOptionInsUpd } from "../../../redux/routine/routineItemOptionInsUpdSlice";
import { assertImagesUrl } from "../../../redux/common";
import { colorName } from "../../../redux/routine/routine";

export function RoutineItemOptionInsUpdReview() {
    const routineItemOptionInsUpd = useSelector(selectRoutineItemOptionInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão da Opção
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{routineItemOptionInsUpd.routineItemOption.name}</Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Ordem</Typography>
            </Grid>
            <Grid size={4}>
                <Typography component="div" variant="body1" color="darkblue">{routineItemOptionInsUpd.routineItemOption.order}</Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Cor</Typography>
            </Grid>
            <Grid size={4}>
                <Typography component="div" variant="body1" color="darkblue">
                    {colorName(routineItemOptionInsUpd.routineItemOption.color)}
                </Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Avatar</Typography>
            </Grid>
            <Grid size={10}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(routineItemOptionInsUpd.routineItemOption.url)}
                        alt={routineItemOptionInsUpd.routineItemOption.name}
                        sx={{ width: 40, height: 40, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
        </Grid>
        <Divider flexItem />
    </>;
}